<div class="modal-background" bdFxLayoutAlign="center start">
    <div class="projects-modal">
        <div bdFxLayoutAlign="space-between center" class="header">
            <!--            <div bdFxFlex bdFxLayoutAlign="start center" class="cancel" (click)="onCancelBtnClicked()">Abbrechen</div>-->
            <!--            <button bdFxFlex bdFxLayoutAlign="start center" class="cancel" (click)="onCancelBtnClicked()" type="button">Abbrechen</button>-->
            <div bdFxFlex bdFxLayoutAlign="start center" class="cancel">
                <button (click)="onCancelBtnClicked()" type="button">Abbrechen</button>
            </div>
            <div bdFxFlex="1 1 auto" bdFxLayoutAlign="center center" class="title">Hardware hinzufügen</div>
            <div bdFxFlex bdFxLayoutAlign="end center" class="save">
                <button class="bd-blue-button" (click)="onSubmitBtnClicked()" type="button">Hinzufügen</button>
            </div>
        </div>
        <form class="body">
            <div class="table">
                <div class="filter-header">
                    <div class="filter" (click)="onFilterBtnClicked()">
                        Filter
                    </div>
                    <button (click)="onResetBtnClicked()" type="button"
                            [disabled]="!(activeTopFilterCheckBoxes || activeBottomFilterCheckBoxes || lowerCaseActiveSearchPhrase || searchPhrase)">
                        <bd-fa [name]="'undo'"></bd-fa>
                        <span>Reset</span>
                    </button>

                </div>


                <div class="filter-search-text-input">

                    <span class="placeholder" *ngIf="!searchPhrase">
                        <bd-fa [name]="'search'"></bd-fa>
                        <span>Suchen...</span>
                    </span>
                    <bd-labeled-input [(ngModel)]="searchPhrase"
                                      (ngModelChange)="announceSearchTermChanged($event)"
                                      [name]="'search'">
                    </bd-labeled-input>

                </div>

                <div class="filter-checkboxes-container">
                    <div class="checkbox-group">
                        <div *ngFor="let checkBox of topFilterCheckBoxes"
                             class="filter-checkbox-item">
                            <bd-checkbox-squared [name]="checkBox.name"
                                                 [(ngModel)]="checkBox.isSelected"
                                                 (ngModelChange)="onFilterCheckboxValueChange()">
                                {{checkBox.label}}
                            </bd-checkbox-squared>
                        </div>
                    </div>
                    <div class="checkbox-group">
                        <div *ngFor="let checkBox of bottomFilterCheckBoxes"
                             class="filter-checkbox-item">
                            <bd-checkbox-squared [name]="checkBox.name"
                                                 [(ngModel)]="checkBox.isSelected"
                                                 (ngModelChange)="onFilterCheckboxValueChange()">
                                {{checkBox.label}}
                            </bd-checkbox-squared>
                        </div>
                    </div>
                </div>

                <div class="table-body">
                    <ng-container *ngFor="let deviceContainer of filteredDevicesContainers">

                        <div class="table-row">
                            <div class="column-article-cell">
                                <app-product-label [orderItemContainer]="deviceContainer"></app-product-label>
                            </div>

                            <div class="icon-cell">
                                <div class="print-smart-icon" *ngIf="isSmartPrint( deviceContainer.itemToOrder )">
                                    <img [res-src]="'./assets/img/logo-print-smart/icon_mps.png'"
                                         [res-sizes]="['2x', '3x']"/>
                                </div>
                            </div>
                            <div class="button-cell">
                                <bd-checkbox-rounded [name]="deviceContainer.id"
                                                     [(ngModel)]="deviceContainer.containerSharedMetadata.addToProductOrderList"
                                                     (ngModelChange)="onDeviceCheckboxClicked( deviceContainer )">

                                </bd-checkbox-rounded>
                            </div>
                        </div>
                    </ng-container>

                </div>

            </div>
        </form>
    </div>
</div>

